import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'

export const StyledTNAppDownloadPage = styled('div')({
    flexDirection: 'column',

    gap: calcRem(40),
    padding: calcRem(0, 24),
    display: 'flex',
    alignItems: 'center',

    [breakpoint('sm')]: {
        gap: calcRem(64),
        width: '100%',
        maxWidth: calcRem(834),
        padding: calcRem(0, 32),
    },

    [breakpoint('lg')]: {
        flexDirection: 'row',
        gap: calcRem(80),
        width: '100%',
        maxWidth: calcRem(1257),
        padding: '0px',
    },
})

export const StyledTNAppDownloadPageWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'center',
})
